/* eslint-disable @typescript-eslint/default-param-last */
import {
  ABORT_RUN_CODE,
  CUSTOM_INPUT_RUN_CODE,
  END_INTERVIEW_FOR_ALL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  SET_ABORT_RUN_CODE_IN_PROCESS,
  SET_RUN_CODE_IN_PROCESS,
  TEST_CASE_RUN_CODE,
} from "../constants/ActionTypes";
import initialState from "../store/initialState";
import { ICodingProblemsType } from "../types/codingProblems.types";

// create a union type using respective actions types

const codingProblemsReducer = (
  state = initialState.codingProblems,
  action: ICodingProblemsType,
) => {
  switch (action.type) {
    case SET_RUN_CODE_IN_PROCESS: {
      const { questionSlug, inProcess } = action.payload;
      const isRunCodeInProcess = { ...state.isRunCodeInProcess };
      isRunCodeInProcess[questionSlug] = inProcess;
      return {
        ...state,
        isRunCodeInProcess,
      };
    }
    case `${TEST_CASE_RUN_CODE}_INITIATED`: {
      const { testCasesResult, solutionId } = action.payload;
      const customInputResults = { ...state.customInputResults };
      delete customInputResults[solutionId];
      const testCaseResults = { ...state.testCaseResults };
      testCaseResults[solutionId] = {
        status: "UNE",
        testCases: testCasesResult,
      };
      return { ...state, testCaseResults, customInputResults };
    }
    case `${CUSTOM_INPUT_RUN_CODE}_INITIATED`: {
      const { solutionId, sid } = action.payload;
      const customInputResults = { ...state.customInputResults };
      customInputResults[solutionId] = { sid };
      return { ...state, customInputResults };
    }
    case `${CUSTOM_INPUT_RUN_CODE}_RESULT`: {
      const { customInputResult } = action.payload;
      const customInputResults = { ...state.customInputResults };
      const solutionId = Object.keys(customInputResults).find(
        (key) => customInputResults[key].sid === customInputResult.sid,
      );
      if (solutionId) {
        customInputResults[solutionId] = customInputResult;
      }
      return { ...state, customInputResults };
    }
    case `SINGLE_${TEST_CASE_RUN_CODE}_RESULT`: {
      const { solutionId, singleTestCaseResult } = action.payload;
      const testCaseResults = { ...state.testCaseResults };
      const currentTestCases = testCaseResults[solutionId]?.testCases;
      const currentTestCaseStatus = testCaseResults[solutionId]?.status;
      if (currentTestCases?.length && currentTestCaseStatus === "UNE") {
        const testCaseIndex = currentTestCases.findIndex(
          (testCase) => testCase.id === singleTestCaseResult.id,
        );
        testCaseResults[solutionId].testCases[testCaseIndex] =
          singleTestCaseResult;
      }
      return { ...state, testCaseResults };
    }
    case `${TEST_CASE_RUN_CODE}_RESULT`: {
      const { solutionId, status, testCasesResult, isInitialUpate } =
        action.payload;
      const testCaseResults = { ...state.testCaseResults };
      const currentTestCaseStatus = testCaseResults[solutionId]?.status;
      const sortedTestCaseResults = testCasesResult.sort(
        (testcaseA, testcaseB) => {
          if (testcaseA.is_sample && testcaseB.is_sample) return 0;
          if (testcaseA.is_sample) return -1;
          return 1;
        },
      );
      if (isInitialUpate) {
        testCaseResults[solutionId] = {
          status,
          testCases: sortedTestCaseResults,
        };
      } else if (currentTestCaseStatus === "UNE") {
        testCaseResults[solutionId].status = status;
        testCaseResults[solutionId].testCases = sortedTestCaseResults;
      }
      return { ...state, testCaseResults };
    }
    case SET_ABORT_RUN_CODE_IN_PROCESS: {
      const { questionSlug, inProcess } = action.payload;
      const isAbortInProcess = { ...state.isAbortInProcess };
      isAbortInProcess[questionSlug] = inProcess;
      return { ...state, isAbortInProcess };
    }
    case `${ABORT_RUN_CODE}_SUCCESS`: {
      const { questionSlug, solutionId, testCases, status } = action.payload;
      const isRunCodeInProcess = { ...state.isRunCodeInProcess };
      const isAbortInProcess = { ...state.isAbortInProcess };
      const testCaseResults = { ...state.testCaseResults };
      const customInputResults = { ...state.customInputResults };
      const currentTestCaseStatus = testCaseResults[solutionId]?.status;
      if (currentTestCaseStatus === "UNE") {
        if (testCases?.length && status) {
          testCaseResults[solutionId] = {
            status,
            testCases,
          };
        } else {
          delete testCaseResults[solutionId];
        }
      }
      delete customInputResults[solutionId];
      isRunCodeInProcess[questionSlug] = false;
      isAbortInProcess[questionSlug] = false;
      return {
        ...state,
        testCaseResults,
        customInputResults,
        isRunCodeInProcess,
        isAbortInProcess,
      };
    }
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.codingProblems;
    default: {
      return state;
    }
  }
};

export default codingProblemsReducer;
